export const mVMixin = {
    methods: {
        formatDate(timeStr) {
            let temp = new Date(timeStr)
            let newFormat = ''
            if (temp instanceof Date && !isNaN(temp)) {
                let monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
                let date = temp.getDate()
                let month = monthNames[temp.getMonth()]
                let year = temp.getFullYear()
                if (date < 10) {
                    date = '0' + '' + date
                }
                newFormat = date + '-' + month + '-' + year
            } else {
                temp = timeStr.split(/(\s+)/)[0].split('-').reverse()
                let month = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
                temp[1] = month[parseInt(temp[1]) - 1]
                newFormat = temp.join('-')
                if (newFormat.charAt(0) === '0') {
                    newFormat = newFormat.slice(1)
                }
            }
            return newFormat
        },
        formatTime(timeStr) {
            let temp = new Date(timeStr)
            let timeFormat = ''
            if (temp instanceof Date && !isNaN(temp)) {
                let temp1 = ''
                if (timeStr.split(' ')[1]) {
                    temp1 = timeStr.split(' ')[1]
                } else if (timeStr.split('T')[1]) {
                    temp1 = timeStr.split('T')[1]
                    temp1 = temp1.split('.')[0]
                }
                timeFormat = temp1
            } else {
                let temp1 = ''
                if (timeStr.split(/(\s+)/)[2]) {
                    temp1 = timeStr.split(/(\s+)/)[2]
                }
                timeFormat = temp1
            }
            return timeFormat
        },
        apiDateFormat(timeStr) {
            let temp = new Date(timeStr)
            let newFormat = ''
            if (temp instanceof Date && !isNaN(temp)) {
                let date = temp.getDate()
                let month = temp.getMonth() + 1
                let year = temp.getFullYear()
                if (date < 10) {
                    date = '0' + '' + date
                }
                if (month < 10) {
                    month = '0' + '' + month
                }
                newFormat = year + '-' + month + '-' + date
            }
            return newFormat
        },
        convertDate(val) {
            if (val) {
                var event = new Date(val)
                let date = JSON.stringify(event)
                date = date.slice(1, 11)
                return date
            } else {
                return ''
            }
        },
        actMakeObjectToParams(obj) {
            var str = "";
            for (var key in obj) {
                if (str != "") {
                    str += "&";
                }
                str += key + "=" + obj[key];
            }
            return str;
        },
        actMakeSizeConversion(arr) {
            return arr.map((item) => {
                if (item.size && !(item.size.toString().includes('MB') || item.size.toString().includes('GB'))) {
                    item.size = (parseFloat(item.size) / (1024 * 1024)).toFixed(2);
                    item.size = item.size + ' ' + 'MB'
                    if (parseFloat(item.size) > 1024) {
                        item.size = (parseFloat(item.size) / (1024)).toFixed(2);
                        item.size = item.size + ' ' + 'GB'
                    }
                    return item;
                } else {
                    return item
                }
            })

        },
        setUniqueId(arr) {
            return arr.map((item, index) => {
                item.checkid = item.filename + (item.preprocessid ? item.preprocessid : index)
                return item;
            })
        },
        actDurationConversion(arr) {
            return arr.map((item) => {
                item.duration = this.toHHMMSS(item.duration)
                return item;
            })
        },
        actResponseConversion(arr) {
            this.actMakeSizeConversion(arr)
            this.setUniqueId(arr)
            let item = this.actDurationConversion(arr)
            return item

        },
        capitalize(s) {
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
        },
        filterParam(filterValue, concatData) {
            for (let data in filterValue) {
                if (typeof(filterValue[data]) === "object") {
                    console.log(filterValue[data])
                    concatData = this.filterParam(filterValue[data], concatData)
                } else {
                    let res = `${data}=${filterValue[data]}&`
                    concatData = concatData.concat(res)
                }
            }
            return concatData
                // console.log("ConcatBefore||", concatData)
                // let splitStr = concatData.split('&')
                // console.log("length", splitStr.length)
                // splitStr.splice(splitStr.length - 1, 1)
                // console.log("ConcatAfter||", splitStr)

        },
        getParam(obj) {
            var str = [];
            for (var p in obj) {
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            }
            return str.join("&");
        },
        getLanguage(filename) {
            let language = { name: "", code: "" };
            let lang = filename.split("_");
            lang = lang[lang.length - 1].split(".")[0];
            console.log("lang", lang);
            languages.forEach(value => {
                if (lang.toLowerCase() === value["alpha3-b"]) {
                    language.name = value.English.toUpperCase();
                    language.code = value["alpha3-b"];
                }
            });
            return language;
        },
        checkTokenExpiry(error) {
            console.log('checkTokenExpiry')
            if ((error.errorcode == 407 || error.errorcode == 401 || error.errorcode == 302) ) {
                // let url = error.reason && error.reason.includes("https") ? error.reason : 'https://vlive-cms.firebaseapp.com'
                let url = "https://vauthprovider-529d8.web.app/"
                if (BUILDTYPE == 'PROD') {
                    url = 'https://vauth.mobiotics.com'
                }
                let redirectUrl = `${url}?serviceurl=${window.location.origin}&servicename=vtranscode`;
                localStorage.clear()
                sessionStorage.clear()
                window.location.replace(redirectUrl);
            }
        },
        toHHMMSS(duration) {
            var sec_num = parseInt(duration, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            return hours + ':' + minutes + ':' + seconds;
        },
        sizeConverterToBytes(size) {
            if (size.toString().includes('MB')) {
                size = Math.round((parseFloat(size) * (1024 * 1024)))
            } else if (size.toString().includes('GB')) {
                size = Math.round((parseFloat(size) * (1024 * 1024 * 1024)))
            }
            return size
        },
        getFileSize(size) {
            if (!(size.toString().includes('MB') || size.toString().includes('GB'))) {

                size = (parseInt(size) / (1024 * 1024)).toFixed(2);
                size = size + " " + "MB";

                if (parseInt(size) > 1024) {
                    size = size + " " + "GB";
                }
                return size;
            } else {
                return size
            }
        },
        checkRedundant(arr) {
            // console.log("Array", arr)
            let result = []
            result = arr.reduce((unique, currentval) => {
                if (!unique.some(obj => obj.checkid === currentval.checkid)) {
                    unique.push(currentval);
                }
                return unique;
            }, []);
            // console.log("res>>", result);
            return result;
        },
        getArrValue(value) {
            if (value) {
                return value.map((ele) => {
                    return ele && ele.filename;
                    // return `{filename:${ele.filename},language:${ele.language}}`;
                });
            } else {
                return "";
            }
        },
        handleUnauthorized(error) {
            let url = "https://vauthprovider-529d8.web.app/"
            if (BUILDTYPE == 'PROD') {
                url = 'https://vauth.mobiotics.com'
            }
            let redirectUrl = `${url}?serviceurl=${window.location.origin}&servicename=vtranscode`;
            localStorage.clear()
            sessionStorage.clear()
            window.location.replace(redirectUrl);
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins.js